import { classes } from "portal/theme/theme";
import { getAxisTicks, getYAxisTickLabelX, ShootTimeYScale } from "./layout";
import { useTheme } from "@mui/material";
import React, { FunctionComponent, useMemo } from "react";

/** Numeric Y scale and a horizontal gridline on each tick. */
export interface ShootTimeChartYAxisProps {
  plotLeft: number;
  plotWidth: number;
  yMax: number;
  yScale: ShootTimeYScale;
  className?: string;
}

export const ShootTimeChartYAxis: FunctionComponent<
  ShootTimeChartYAxisProps
> = ({ plotLeft, plotWidth, yMax, yScale, className }) => {
  const {
    palette: {
      chart: { gridColor, tickColor },
    },
  } = useTheme();
  const ticks = useMemo(() => getAxisTicks(yMax), [yMax]);
  const plotRight = plotLeft + plotWidth;
  const labelX = getYAxisTickLabelX(plotLeft);

  return (
    <>
      {ticks.map((tick) => {
        const lineY = yScale(tick);
        return (
          <g key={tick}>
            <line
              x1={plotLeft}
              x2={plotRight}
              y1={lineY}
              y2={lineY}
              stroke={gridColor}
              strokeWidth={1}
              className={className}
            />
            {tick > 0 && (
              <text
                x={labelX}
                y={lineY}
                textAnchor="end"
                dominantBaseline="middle"
                fill={tickColor}
                className={classes("text-xs", className)}
              >
                {tick}
              </text>
            )}
          </g>
        );
      })}
    </>
  );
};
